import { render, staticRenderFns } from "./RoleFormView.vue?vue&type=template&id=400f8948&scoped=true"
import script from "./RoleFormView.vue?vue&type=script&lang=js"
export * from "./RoleFormView.vue?vue&type=script&lang=js"
import style0 from "./RoleFormView.vue?vue&type=style&index=0&id=400f8948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f8948",
  null
  
)

export default component.exports